import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, { useState, useEffect } from "react";
import "react-loading-skeleton/dist/skeleton.css";

import Footer from "./pages/footer";
import SuccessPage from "./pages/successPage";
import PrivacyPage from "./pages/PrivacyPage";
import ErrorPage from "./pages/errorPage";
import Translitration from "./pages/tracks/Translitration";
import AllTracks from "./pages/tracks/AllTracks";
import LandingPage from "./pages/LandingPage";
import LandingSkelton from "./pages/skelton/LandingSkelton";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AuthPopup from "./components/AuthPopup";
import HolidayPromoModal from "./components/HolidayPromoModal";

function AppContent() {
  const [loading, setLoading] = useState(true);
  const { isAuthOpen, toggleAuthModal } = useAuth();

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 3000);
  }, []);

  return (
    <>
      <Routes>
          <Route
            index
            element={loading ? <LandingSkelton /> : <LandingPage />}
            // element={<LandingPage />}
          />
          {/* <Route
            path="booking"
            element={loading ? <RecordingSkelton /> : <BookingPage />}
            element={loading ? <PrivacySkelton /> : <BookingPage />}
          /> */}
          <Route path="tracks" element={<Translitration />} />
          <Route path="alltracks" element={<AllTracks />} />
          <Route path="privacy" element={ <PrivacyPage />} />
          <Route path="success" element={<SuccessPage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      {!loading && <Footer />}
      <HolidayPromoModal />
      <AuthPopup isOpen={isAuthOpen} onClose={() => toggleAuthModal(false)} />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
